// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2.5 5H11.0001V12.6507L6.51825 19H3.79467L6.46133 13H2.5V5ZM13 5H21.5V12.6507L17.0182 19H14.2946L16.9612 13H13V5Z"}}]};

const QuoteFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'quote-filled',
    ref,
    icon: element,
  },
));

QuoteFilledIcon.displayName = 'QuoteFilledIcon';

export default QuoteFilledIcon;
